import classNames from "../../functions/classNames";

export default function TokenFieldRow({
  words,
  values,
  onChange,
  selectedWordId,
  onSelect,
  isSuggestion,
  dir = "ltr",
  mono = false,
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {words.map((word) => {
        const value = values[word.id] ?? "";
        const suggested = Boolean(isSuggestion?.(word, value));
        return (
          <input
            key={word.id}
            type="text"
            value={value}
            dir={dir}
            onFocus={() => onSelect(word.id)}
            onChange={(event) => onChange(word.id, event.target.value)}
            className={classNames(
              "min-w-[4.5rem] max-w-[12rem] rounded-md px-2 py-1 text-sm ring-1 ring-inset",
              "bg-white dark:bg-ramsalab-deep-navy dark:text-white",
              mono && "font-mono",
              word.id === selectedWordId
                ? "ring-2 ring-ramsalab-teal-blue bg-ramsalab-teal-blue/10"
                : "ring-gray-300 dark:ring-ramsalab-light-navy",
              suggested && "italic text-amber-700 dark:text-amber-300"
            )}
          />
        );
      })}
    </div>
  );
}
